import { render, staticRenderFns } from "./LinkProductList.vue?vue&type=template&id=42d1e1da&"
import script from "./LinkProductList.vue?vue&type=script&lang=js&"
export * from "./LinkProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports